let _this = null

const setThis = function(__this) {
  _this = __this
}

export default {
  setThis,
  costUser() { // 获取办理人
    _this.$post('/fesback/dataQuery/user.z').then(res => {
      _this.viewTemplate.userArr = res.data
    }).catch(err => {
      _this.$message.error('系统异常！' + err)
    })
  },
  serviceStation(code) { // 获取服务站
    _this.$post('/fesback/dataQuery/serviceStation.z', { JOB_NUMBER: code }).then(res => {
      _this.viewTemplate.serviceStationArr = res.data.list
      _this.viewTemplate.title = res.data.title
    }).catch(err => {
      _this.$message.error('系统异常！' + err)
    })
  },
  subject(code) { // 获取科目
    _this.$post('/fesback/dataQuery/subject.z', { JOB_NUMBER: code }).then(res => {
      _this.viewTemplate.subjectArr = res.data
    }).catch(err => {
      _this.$message.error('系统异常！' + err)
    })
  },
  async customer() { // 获取客户
    await _this.$post('/fesback/dataQuery/customer.z', { name: '' }).then(res => {
      _this.viewTemplate.customerArr = res.data
    }).catch(err => {
      _this.$message.error('系统异常！' + err)
    })
  },
  queryCostBill(val) { // 获取费用报销的
    _this.$post('/fesback/dataQuery/queryCostBill.z', { name: val }).then(res => {
      _this.viewTemplate.costBillArr = res.data
    }).catch(err => {
      _this.$message.error('系统异常！' + err)
    })
  },
  dateToString(val) { //时间转字符串 yyyy-MM-dd
    var usMonth = parseInt(val.getMonth()) + 1
    var month = usMonth > 9 ? usMonth : '0' + usMonth
    var day = val.getDate() > 9 ? val.getDate() : '0' + val.getDate()
    return val.getFullYear() + '-' + month + '-' + day
  },
  getCostSummaries() {
    let je = 0.00
    _this.viewTemplate.cost.forEach(value => {
      if (value.je && value.je !== '') {
        je += Number(value.je) * 100
      }
    })
    _this.viewTemplate.costTotalJe = Number(je / 100).toFixed(2)
    return ['', '合计', '', Number(je / 100).toFixed(2), '']
  },
  getInvoiceSummaries() {
    let je = 0
    let se = 0
    _this.viewTemplate.invoice.forEach(value => {
      if (value.je && value.je !== '') {
        je += Number(value.je).toFixed(2) * 100
      }
      if (value.se && value.se !== '') {
        se += Number(value.se).toFixed(2) * 100
      }
    })
    _this.viewTemplate.invoiceTotalSe = Number(se / 100).toFixed(2)
    return ['', '合计', '', '', '', Number(je / 100).toFixed(2), '', Number(se / 100).toFixed(2)]
  },
  getJurisdiction() {
    // 查询 cost_collection_query
    // 填报 cost_collection_bill
    // 会计 cost_collection_account
    const haveRoles = JSON.parse(localStorage.getItem('haveRoles'))
    let jurisdiction = ''
    haveRoles.forEach(value => {
      if (value.roleCode === 'cost_collection_query') { //查询
        jurisdiction = 'query'
      } else if (value.roleCode === 'cost_collection_bill') { //填报
        jurisdiction = 'bill'
      } else if (value.roleCode === 'cost_collection_account') { //会计
        jurisdiction = 'account'
      }
    })
    return jurisdiction
  },
  /* 小写数字转大写 */
  convertCurrency(money) {
    //汉字的数字
    var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
    //基本单位
    var cnIntRadice = ['', '拾', '佰', '仟']
    //对应整数部分扩展单位
    var cnIntUnits = ['', '万', '亿', '兆']
    //对应小数部分单位
    var cnDecUnits = ['角', '分', '毫', '厘']
    //整数金额时后面跟的字符
    var cnInteger = '整'
    //整型完以后的单位
    var cnIntLast = '元'
    //最大处理的数字
    var maxNum = 999999999999999.9999
    //金额整数部分
    var integerNum
    //金额小数部分
    var decimalNum
    //输出的中文金额字符串
    var chineseStr = ''
    //分离金额后用的数组，预定义
    var parts
    if (money === '') { return '' }
    money = parseFloat(money)
    if (money >= maxNum) {
      //超出最大处理数字
      return ''
    }
    if (money === 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger
      return chineseStr
    }
    //转换为字符串
    money = money.toString()
    if (money.indexOf('.') === -1) {
      integerNum = money
      decimalNum = ''
    } else {
      parts = money.split('.')
      integerNum = parts[0]
      decimalNum = parts[1].substr(0, 4)
    }
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
      var zeroCount = 0
      var IntLen = integerNum.length
      for (var i = 0; i < IntLen; i++) {
        var n = integerNum.substr(i, 1)
        var p = IntLen - i - 1
        var q = p / 4
        var m = p % 4
        if (n === '0') {
          zeroCount++
        } else {
          if (zeroCount > 0) {
            chineseStr += cnNums[0]
          }
          //归零
          zeroCount = 0
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
        }
        if (m === 0 && zeroCount < 4) {
          chineseStr += cnIntUnits[q]
        }
      }
      chineseStr += cnIntLast
    }
    //小数部分
    if (decimalNum !== '') {
      const decLen = decimalNum.length
      for (let i = 0; i < decLen; i++) {
        const n = decimalNum.substr(i, 1)
        if (n !== '0') {
          chineseStr += cnNums[Number(n)] + cnDecUnits[i]
        }
      }
    }
    if (chineseStr === '') {
      chineseStr += cnNums[0] + cnIntLast + cnInteger
    } else if (decimalNum === '') {
      chineseStr += cnInteger
    }
    return chineseStr
  },
  formatAmount(value) {
    //传入值不是数字直接返回0
    if (!value) return '0.00'
    const values = value.toString().split('.')
    // 整数部分
    let integerNum = values[0]
    // 小数部分
    let decimalNum = values[1] ? values[1] : '00'
    decimalNum = decimalNum.length === 1 ? decimalNum + 0 : decimalNum
    //传入值小于1000不切割
    if (integerNum < 1000) {
      return `${integerNum}.${decimalNum}`
    }
    const list = []
    while (integerNum.length > 3) {
      // 倒序切割
      list.unshift(integerNum.slice(-3))
      integerNum = integerNum.slice(0, -3)
    }
    // 处理剩余长度
    list.unshift(integerNum)
    return `${list.join(',')}.${decimalNum}`
  }

}
